import { ApplicationAuthorization } from "../../../../swagger-gen/gnvert-secured/models/application-authorization";
import { ApplicationFeature } from "../../../../swagger-gen/gnvert-secured/models/application-feature";

export class UserAuthorizationModel {

    feature: ApplicationFeature;
    readOnly: boolean;

    constructor(applicationAuthorization: ApplicationAuthorization) {
        this.feature = applicationAuthorization.feature;
        this.readOnly = applicationAuthorization.readOnly || false;
    }

    public static getListFromApi(res: ApplicationAuthorization[]): UserAuthorizationModel[] {
        const list: UserAuthorizationModel[] = [];
        if (res) {
            res.forEach(r => {
                list.push(new UserAuthorizationModel(r));
            });
        }

        return list;
    }
}
